<apm-icon
  size="md"
  [matTooltipPosition]="matTooltipPosition"
  [matTooltipClass]="matTooltipClass"
  [isButton]="true"
  [hasHoverIcon]="true"
  [disabled]="disabled || documentIsInProgress"
  (iconClick)="!documentIsInProgress && (documentIsComplete ? downloadDocument() : onCreateDocument($event))"
  icon="a_download_document"
  matTooltip="{{ (documentIsComplete ? '445258' : '445259') | apmTranslate }}"
></apm-icon>
